import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './Sidebar';
import '../App.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { toast } from 'react-toastify';

export default function Header(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate(); // For programmatic navigation after logout
  const apiUrl = process.env.REACT_APP_API_URL;

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    try {
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/auth/logout`,
        headers: {
          Authorization: token, // Use token from localStorage
        },
      };

      const response = await axios.request(config);
      // Clear user data and navigate to the login page
      localStorage.clear();
      setDropdownOpen(false);
      navigate('/');
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  return (
    <>
      {props.sidebarOpen ? (
        <Sidebar
          P1={props.P1}
          R1={props.R1}
          I1={props.i1}
          Ac1={props.Ac1}
          P2={props.P2}
          R2={props.R2}
          I2={props.i2}
          Ac2={props.Ac2}
          P3={props.P3}
          R3={props.R3}
          I3={props.i3}
          f3={props.f3}
          Ac3={props.Ac3}
          P4={props.P4}
          R4={props.R4}
          I4={props.i4}
          Ac4={props.Ac4}
          P5={props.P5}
          R5={props.R5}
          I5={props.i5}
          f5={props.f5}
          Ac6={props.Ac6}
          P6={props.P6}
          R6={props.R6}
          I6={props.i6}
          Ac7={props.Ac7}
          P7={props.P7}
          R7={props.R7}
          I7={props.i7}
          Ac8={props.Ac8}
          P8={props.P8}
          R8={props.R8}
          I8={props.i8}
          Ac9={props.Ac9}
          P9={props.P9}
          R9={props.R9}
          I9={props.i9}
          Ac10={props.Ac10}
          P10={props.P10}
          R10={props.R10}
          I10={props.i10}
          P11={props.P11}
          R11={props.R11}
          I11={props.i11}
          Ac11={props.Ac11}
          P12={props.P12}
          R12={props.R12}
          I12={props.i12}
          Ac12={props.Ac12}
          P13={props.P13}
          R13={props.R13}
          I13={props.i13}
          Ac13={props.Ac13}
          P14={props.P14}
          R14={props.R14}
          I14={props.i14}
          Ac14={props.Ac14}
          P15={props.P15}
          R15={props.R15}
          I15={props.i15}
          Ac15={props.Ac15}
          P16={props.P16}
          R16={props.R16}
          I16={props.i16}
          Ac16={props.Ac16}
          DR={props.DR}
        />
      ) : null}

      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between">
          <Link to={props.h1} className="logo d-flex align-items-center">
            <img src="assets/img/logo.png" alt="" />
            <span className="d-none d-lg-block">{props.Heading}</span>
          </Link>
        </div>
        <i
          className="bi bi-list toggle-sidebar-btn"
          style={{ paddingLeft: `${props.Btn}px` }}
          onClick={() => props.setSidebarOpen(!props.sidebarOpen)}
        ></i>

        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown pe-3">
              <div
                className="nav-link nav-profile d-flex align-items-center pe-0"
                onClick={toggleDropdown}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src="assets/img/profile-img.png"
                  alt="Profile"
                  className="rounded-circle"
                />
                <span className="d-none d-md-block dropdown-toggle ps-2">
                  {props.user}
                </span>
              </div>

              {dropdownOpen && (
                <ul
                  className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile show"
                  style={{
                    position: 'absolute',
                    inset: '0px 0px auto auto',
                    margin: '0px',
                    transform: 'translate(-16.5017px, 38.5039px)',
                  }}
                >
                  <li className="dropdown-header">
                    <h6>{props.user}</h6>
                    <span>{props.role}</span>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      to={props.opr}
                      className="dropdown-item d-flex align-items-center"
                    >
                      <i className={props.opi}></i>
                      <span>{props.op}</span>
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      to={props.opr1}
                      className="dropdown-item d-flex align-items-center"
                    >
                      <i className={props.opi1}></i>
                      <span>{props.op1}</span>
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="dropdown-item d-flex align-items-center"
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}
